<template>
    <v-flex class="polices_procedures" v-if="checkPolicyHeading">

        <h2>{{policiesProceduresConstants.POLICIES_PROCEDURES}} <small>{{getRevisionText()}}</small> </h2>

        <v-flex class="polices_procedures__row">
            <v-flex class="search_bar">
                <v-text-field
                    append-icon="search"
                    single-line
                    slot="activator"
                    label="Search YPO Policies and Procedures"
                    data-qe-id="pnP-Search"
                    clearable
                    solo
                    flat
                    hide-details
                    v-model="searchText"
                    @keyup="searchPnP"
                    @click:clear="clearSearchText()">
                </v-text-field>
            </v-flex>
            <v-tabs
                slider-color="ypo_gold"
                background-color="transparent"
                class="polices_procedures__row__tab"
                v-model="currentTab"
                :hide-slider="disableTabs">
                <v-tab
                    class="polices_procedures__row__tab__main"
                    v-for="policies in getHeadings"
                    :key="policies.id"
                    @click="getArticles(policies.id)"
                    :disabled="disableTabs"
                    :data-qe-id="`pnp_tab_${policies.name}`">
                    {{policies.name}}
                </v-tab>

                <v-tabs-items touchless>
                    <v-tab-item
                        class="polices_procedures__row__tab__main__child"
                        v-for="(policies, index) in getHeadings"
                        v-show="currentTab === index"
                        :key="index">
                        <v-flex v-if="currentTab === index">
                            <v-flex
                                v-if="currentTab === 0 && !showSearchResults"
                                v-html="policies.contentData"
                                class="polices_procedures__overView">
                            </v-flex>
                            <v-flex class="polices_procedures__search" v-else-if="showSearchResults">
                                <span class="no-result" v-if="noResults">{{policiesProceduresConstants.NO_RESULT_FOUND}}</span>
                                <v-flex v-else>
                                    <v-flex
                                        v-if="loadSearchAction.pending"
                                        justify-center
                                        text-xs-center>
                                        <v-progress-circular indeterminate></v-progress-circular>
                                    </v-flex>
                                    <v-flex
                                        class="result"
                                        v-for="(result, index) in searchPoliciesAndProcedures"
                                        :key="index"
                                        @click="goToTab(result)"
                                        :data-qe-id="`search_pnp_${index}`"
                                        v-show="!loadSearchAction.pending">
                                        <strong xs12>
                                            {{result.tabName}}
                                        </strong>
                                        <em v-if="result.articleName" v-highlight="{keyword: highlightText, sensitive: false}">
                                            {{result.articleName}} {{result.sectionName ? policiesProceduresConstants.SLASH : ''}} {{result.sectionName}}
                                        </em>
                                        <p v-highlight="{keyword: highlightText, sensitive: false}">
                                            {{result.contents}}
                                        </p>
                                    </v-flex>
                                    <back-to-top></back-to-top>
                                </v-flex>
                            </v-flex>
                            <v-tabs
                                show-arrows
                                v-model="activeTab[index]"
                                v-else>
                                <v-tabs-slider color="transparent"></v-tabs-slider>

                                <v-tab
                                    v-for="(articles, i) in policiesArticles"
                                    :key="i"
                                    class="items"
                                    @click="getArticlesDataById(articles.id)"
                                    :data-qe-id="`pnp_article_${i+1}`">
                                    <span v-html="getArticleName(articles.name)">
                                    </span>
                                </v-tab>
                                <v-tabs-items touchless>
                                    <v-tab-item v-for="(articles, i) in policiesArticles" :key="i">
                                        <status-overlay :action="loadPoliciesAction"></status-overlay>
                                        <v-flex v-if="articleData">
                                            <v-layout
                                                class="polices_procedures__cont sidebar"
                                                row
                                                wrap
                                                v-if="!$vuetify.breakpoint.xs">
                                                <v-flex sm4 md3>
                                                    <v-flex class="polices_procedures__list_items__scroll inner-scrollbar">
                                                        <v-flex
                                                            class="polices_procedures__list_items"
                                                            v-for="(sections, j) in getArticleById(articles.id)"
                                                            :key="j"
                                                            v-scroll-to="{ el: `#section_${index}_${i}_${j}`, offset: -100 }"
                                                            :data-qe-id="`pnp_section_${j+1}`">
                                                            {{sections.name}}
                                                        </v-flex>
                                                    </v-flex>
                                                    <span v-if="isError">{{policiesProceduresConstants.NO_DATA_FOUND}}</span>
                                                </v-flex>
                                                <v-flex
                                                    sm8
                                                    md9
                                                    class="polices_procedures__inner_cont">
                                                    <div
                                                        v-for="(content, j) in getArticleById(articles.id)"
                                                        :key="j"
                                                        :id="`section_${index}_${i}_${j}`"
                                                        :data-qe-id="`pnp_contentdata_${j+1}`">
                                                        <v-flex v-html="content.contentData">
                                                        </v-flex>
                                                        <span v-if="isError">{{policiesProceduresConstants.NO_DATA_FOUND}}</span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-flex v-if="$vuetify.breakpoint.xs">
                                                <v-expansion-panel class="polices_procedures__expansion">
                                                    <v-expansion-panel-content v-for="(sections, j) in getArticleById(articles.id)" :key="j">
                                                        <div class="" slot="header">
                                                            {{sections.name}}
                                                        </div>
                                                        <v-flex v-html="sections.contentData">
                                                        </v-flex>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-flex>
                                            <back-to-top></back-to-top>
                                        </v-flex>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-tabs>
                        </v-flex>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-flex>

    </v-flex>
</template>

<script>
    import { mapActions, mapGetters, mapState } from "vuex";
    import { storeGetters } from '../../store/storeGetters.constant';
    import { storeAction } from '../../store/storeActions.constant';
    import BackToTop from '../Layout/BackToTop.vue';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import { policiesProceduresConstants } from './policiesProcedures.constants';

    export default {
        name: "PoliciesProcedures",
        components: {
            BackToTop,
            StatusOverlay,
        },
        data: () => ({
            currentTab: 0,
            policiesArticles: null,
            policiesSections: [],
            activeTab: [],
            isError: false,
            policyManual: [],
            policyBylaws: [],
            policiesProceduresConstants,
            searchText: "",
            showSearchResults: false,
            disableTabs: false,
            navigate: false,
            routeId: null,
            noResults: false,
            searchPoliciesAndProcedures: [],
            highlightText: "",
            timeOutTypeAhead: null,
        }),
        created() {
            this.getPoliciesHeadings();
        },
        methods: {
            ...mapActions({
                getPoliciesHeadings: `policiesProcedures/${storeAction.getPoliciesHeadings}`,
                getArticleData: `policiesProcedures/${storeAction.getArticleData}`,
                getPoliciesAndProceduresSearch: `policiesProcedures/${storeAction.getPoliciesAndProceduresSearch}`,
            }),
            compareArticles(a, b) {
                if (a.sequence < b.sequence) {
                    return -1;
                }
                if (a.sequence > b.sequence) {
                    return 1;
                }
                return 0;
            },
            getRevisionText() {
                if (this.policiesHeadings.length > 0) {
                    const revisedText = this.policiesHeadings.filter(item => item.name.includes(this.policiesProceduresConstants.REVISED_DATE));
                    if (revisedText.length > 0) {
                        return revisedText[0].contentData;
                    }
                }
            },
            getArticleName(name) {
                const index = name.indexOf(' ', name.indexOf(' ') + 1);
                let articleName = '';
                const articleNo = name.substr(0, index);
                if (index >= 0) {
                    articleName = name.substr(index + 1);
                }

                return `${articleNo}<br>${articleName}`;
            },
            openManualTab() {
                this.currentTab = 1;
                const policyId = this.policiesHeadings.filter(item =>
                    item.name.includes(this.policiesProceduresConstants.POLICIES_PROCEDURES_MANUAL) &&
                    item.type === this.policiesProceduresConstants.TAB)[0].id;
                this.getArticles(policyId);
            },
            getArticles(policiesId) {
                this.isError = false;
                let isArticleLoaded = 0;
                this.activeTab = [];
                if (this.policyManual.some(x => x.parentId === policiesId)) {
                    this.policiesArticles = this.policyManual;
                } else if (this.policyBylaws.some(x => x.parentId === policiesId)) {
                    this.policiesArticles = this.policyBylaws;
                }
                if (this.policiesArticles.length > 0) {
                    const articleId = this.policiesArticles[0].id;
                    if (this.articleData.length > 0) {
                        isArticleLoaded = this.articleData.filter(item => item.Id === articleId).length;
                        if (!isArticleLoaded) {
                            this.getArticleData(articleId)
                                .catch(() => {
                                    this.isError = true;
                                });
                        }
                    } else if (this.policiesArticles.length > 0) {
                        this.getArticleData(articleId);
                    }
                }
            },
            getArticleById(articleId) {
                this.isError = false;
                if (this.articleData) {
                    const article = this.articleData.filter(item => item.Id === articleId);
                    if (article[0]) {
                        return article[0].data;
                    }
                }
            },
            getArticlesDataById(articleId) {
                this.isError = false;
                let isArticleLoaded = 0;
                if (this.articleData.length > 0) {
                    isArticleLoaded = this.articleData.filter(item => item.Id === articleId).length;
                    if (!isArticleLoaded) {
                        this.getArticleData(articleId);
                    }
                } else {
                    this.getArticleData(articleId);
                }
            },
            addClickEvent() {
                this.$nextTick(() => {
                    document.getElementById('openTab').addEventListener('click', this.openManualTab);
                });
            },
            searchPnP() {
                this.noResults = false;
                this.navigate = false;
                if (!this.isValidSearchToken) {
                    this.clearSearchText();
                    return false;
                }
                this.disableTabs = true;
                this.showSearchResults = true;
                this.searchPoliciesAndProcedures = [];
                clearTimeout(this.timeOutTypeAhead);
                this.timeOutTypeAhead = setTimeout(() => {
                    this.highlightText = this.searchText;
                    if (this.searchText.endsWith(" ") || this.searchText.startsWith(" ")) {
                        this.highlightText = this.searchText.trim();
                    }
                    this.getPoliciesAndProceduresSearch(this.searchText)
                        .then((res) => {
                            this.searchPoliciesAndProcedures = res.data;
                            if (!(this.searchPoliciesAndProcedures.length > 0)) {
                                this.noResults = true;
                            }
                        });
                }, 1000);
            },
            clearSearchText() {
                this.showSearchResults = false;
                this.disableTabs = false;
                if (this.currentTab === 0) {
                    this.addClickEvent();
                }
            },
            goToTab(result) {
                if (result.tabName === this.policiesProceduresConstants.POLICIES_PROCEDURES_OVERVIEW) {
                    this.currentTab = 0;
                }
                if (result.tabName === this.policiesProceduresConstants.POLICIES_PROCEDURES_MANUAL) {
                    this.currentTab = 1;
                }
                if (result.tabName === this.policiesProceduresConstants.YPO_BYLAWS) {
                    this.currentTab = 2;
                }
                if (this.currentTab !== 0) {
                    this.searchArticles(result);
                    this.goToSection(result);
                }
                this.clearSearchText();
                this.searchText = "";
            },
            searchArticles(result) {
                this.activeTab = [];
                let isArticleLoaded = 0;
                if (this.policyManual.some(x => x.parentId === result.tabId)) {
                    this.policiesArticles = this.policyManual;
                } else if (this.policyBylaws.some(x => x.parentId === result.tabId)) {
                    this.policiesArticles = this.policyBylaws;
                }
                if (this.policiesArticles.length > 0) {
                    if (this.articleData.length > 0) {
                        isArticleLoaded = this.articleData.filter(item => item.Id === result.articleId).length;
                        if (!isArticleLoaded) {
                            this.getArticleData(result.articleId)
                                .then(() => {
                                    this.navigate = true;
                                })
                                .catch(() => {
                                    this.isError = true;
                                });
                        }
                    } else if (this.policiesArticles.length > 0) {
                        this.getArticleData(result.articleId)
                            .then(() => {
                                this.navigate = true;
                            });
                    }
                }
            },
            goToSection(result) {
                if (this.policiesArticles.length > 0) {
                    const article = this.policiesArticles.filter(item => item.id === result.articleId)[0];
                    this.activeTab[this.currentTab] = (article.sequence) - 1;
                    if (result.sectionName) {
                        this.routeId = `section_${this.currentTab}_${this.activeTab[this.currentTab]}_${(result.sequence) - 1}`;
                    } else {
                        this.routeId = null;
                    }
                    if (this.articleData.filter(item => item.Id === result.articleId).length > 0) {
                        this.navigate = true;
                    }
                }
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                policiesHeadings: `policiesProcedures/${storeGetters.policiesHeadings}`,
                articleData: `policiesProcedures/${storeGetters.articleData}`,
            }),
            checkPolicyHeading() {
                return this.policiesHeadings && this.policiesHeadings.length > 0;
            },
            getHeadings() {
                return this.policiesHeadings.filter(item => item.type === this.policiesProceduresConstants.TAB);
            },
            loadPoliciesAction() {
                return this.actions[storeAction.getArticleData];
            },
            isValidSearchToken() {
                return this.searchText ? this.searchText.length > 2 : false;
            },
            loadSearchAction() {
                return this.actions[storeAction.getPoliciesAndProceduresSearch];
            },
        },
        watch: {
            policiesHeadings(val) {
                if (this.currentTab === 0) {
                    this.addClickEvent();
                }
                const policyManualId = val.filter(item =>
                    item.name.includes(this.policiesProceduresConstants.POLICIES_PROCEDURES_MANUAL) &&
                    item.type === this.policiesProceduresConstants.TAB)[0].id;
                if (policyManualId) {
                    this.policyManual = val.filter(item =>
                            item.parentId === policyManualId && item.type === this.policiesProceduresConstants.ARTICLE)
                        .sort(this.compareArticles);
                }

                const policyBylawsId = val.filter(item =>
                    item.name.includes(this.policiesProceduresConstants.YPO_BYLAWS) &&
                    item.type === this.policiesProceduresConstants.TAB)[0].id;

                if (policyBylawsId) {
                    this.policyBylaws = val.filter(item =>
                            item.parentId === policyBylawsId && item.type === this.policiesProceduresConstants.ARTICLE)
                        .sort(this.compareArticles);
                }
            },
            currentTab(val) {
                if (val === 0) {
                    this.addClickEvent();
                }
            },
            navigate(val) {
                if (val && this.routeId) {
                    this.$nextTick(() => {
                        const options = {
                            offset: -100,
                        };
                        this.$scrollTo(`#${this.routeId}`, 500, options);
                    });
                }
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";
    @import "../../common/styles/pnpCustomClasses.scss";

    .polices_procedures {
        height: 100vh;
        padding-top: 90px;
        background: $white;

        h2 {
            font-size: 30px;
            color: $ypo-blue;
            line-height: normal;
            font-weight: 500;
            font-family: "Raleway", sans-serif;
            margin-bottom: 20px;
            padding: 0 30px;

            small {
                font-size: 14px;
            }
        }

        &__row {
            position: relative;

            .search_bar {
                position: absolute;
                right: 30px;
                z-index: 1;
                min-width: 400px;

                .v-input__control {
                    min-height: 38px;

                    .v-input__slot {
                        border: 1px solid $ypo-blue;
                        border-radius: 6px !important;

                        .v-icon {
                            color: $ypo-cta;
                            font-size: 26px;
                        }

                        .v-label,
                        input {
                            font-size: 14px;
                        }

                        .v-label {
                            color: $ypo-dark-background-gray;
                        }
                    }
                }
            }

            &__tab {
                .v-tabs__bar {
                    border-bottom: 1px solid $ypo-medium-gray;
                    padding: 0 30px;
                }

                &__main {
                    font-size: 14px;
                    max-width: inherit;
                    text-transform: inherit;

                    a {
                        color: $ypo-blue;

                        &.v-tabs__item--active {
                            font-weight: 600;
                        }
                    }

                    &__child {
                        .v-tabs__bar {
                            border-bottom: none !important;
                            padding: 0 50px;
                            .v-tabs__icon--prev {
                                left: 14px;
                            }
                            .v-tabs__icon--next {
                                right: 14px;
                            }
                        }

                        .v-tabs__container {
                            height: auto;
                        }

                        .items {
                            margin: 25px 0;

                            a {
                                margin: 10px;
                                color: $ypo-blue !important;
                                border-radius: 3px;
                                background: $ypo-extra-light-gray;
                                font-family: "Raleway", sans-serif;
                                opacity: 1;
                                box-shadow: 1px 2px 2px 0 rgba($black, 0.25);
                                font-weight: 500;
                                line-height: 24px;
                                min-height: 100px;
                                text-transform: initial;

                                &.v-tabs__item--active {
                                    background: $ypo-blue;
                                    color: $white !important;
                                }
                            }
                        }

                        .v-tabs__icon {
                            font-size: 40px;
                            color: $ypo-blue;
                            opacity: 0.5;

                            &:hover {
                                opacity: 1;
                            }
                        }
                        .v-tabs__wrapper {
                            margin: 0;
                        }
                    }
                }
            }
        }

        &__tabs-inner {

            .v-tabs__bar {
                display: table-cell;
                width: 23%;
                vertical-align: top;
                border-right: 1px solid $ypo-medium-gray;
                padding: 15px 0;
            }

            .v-window {
                display: table-cell;
                width: 77%;
                vertical-align: top;
            }

            .v-tabs__wrapper {
                width: 100%;
                margin: 0px;
            }

            .v-tabs__container {
                display: block;
                height: auto;
            }

            .v-tabs__div {
                width: 100%;
                max-width: 100%;
                min-width: 100%;
                display: inherit;
                text-align: left;
                text-transform: inherit;

                .v-tabs__item {
                    text-align: left;
                    display: inline-block;
                    padding: 10px 0;
                    font-family: "Raleway", sans-serif;
                    color: $ypo-blue;

                    &--active {
                        font-weight: 600;
                    }
                }
            }

            .v-tabs__slider-wrapper {
                display: none;
            }
        }

        &__overView {
            font-size: 16px;
            padding: 20px 50px !important;
        }

        &__search {
            padding-bottom: 50px;
            margin: 0 30px;

            .result {
                border-bottom: 1px solid $ypo-medium-gray;
                padding: 20px 10px;
                cursor: pointer;
                transition: 0.3s all ease;

                &:hover {
                    background: rgba($ypo-medium-gray, 0.2);
                }

                strong {
                    font-size: 20px;
                    color: $ypo-dark-background-gray;
                    display: block;
                    line-height: normal;

                    span {
                        font-weight: bold;
                        color: $ypo-cta;
                        display: block;
                        line-height: normal;
                    }
                }

                em {
                    display: inline-block;
                    font-size: 16px;
                    color: $ypo-cta;
                    line-height: normal;
                    font-style: normal;
                    margin: 10px 0 10px 0;
                    font-weight: 600;
                }

                p {
                    font-size: 16px;
                    padding: 0;
                    line-height: normal;
                    margin-bottom: 0px;
                }

                .highlighted {
                    background-color: rgba($ypo-gold, 0.6);
                    display: inline-block;
                    color: rgba($black, 0.5) !important;
                }
            }

            .no-result {
                padding: 15px 0 0;
                display: block;
                text-align: center;
                font-size: 16px;
            }

            .v-progress-circular {
                top: 21px;
            }
        }

        &__list_items {
            font-size: 16px;
            color: $ypo-blue;
            cursor: pointer;
            padding: 7px 0px;
            font-family: "Raleway", sans-serif;
            font-weight: 400;

            &.active {
                font-weight: 600;
            }

            &__scroll {
                position: sticky;
                z-index: 1;
                top: 70px;
                max-height: calc(100vh - 70px);
                overflow-y: auto;
                margin: 20px 0;

                /* ----------- iPad Pro ----------- */
                /* Portrait and Landscape */
                @media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
                    top: 100px;
                    max-height: calc(100vh - 110px);
                }

                @media only screen and (min-width: 767px) and (max-height: 1024px) and (-webkit-min-device-pixel-ratio: 1.5) {
                    top: 120px;
                    max-height: calc(100vh - 130px);
                }
            }

        }

        &__cont {
            border-top: 1px solid $ypo-medium-gray;
            border-bottom: 1.5px solid $ypo-medium-gray;
            margin-bottom: 50px;
            padding: 0 30px;
        }

        &__inner_cont {
            border-left: 1px solid $ypo-medium-gray;
            padding-left: 20px;
            padding-top: 25px;
            font-family: Raleway, serif;
            font-weight: 500;

            h2 {
                font-size: 18px;
                color: $ypo-gray-text;
                font-weight: 600;
            }
        }

        @include breakpoint(md) {
            &__row {
                .search_bar {
                    min-width: 300px;
                }
            }
        }

        @include breakpoint(sm) {
            height: auto;
            padding-top: 120px;

            &__row {
                .search_bar {
                    min-width: inherit;
                    width: 100%;
                    top: 58px;
                    right: 0;
                    padding: 0 15px;
                }

                &__tab {
                    &__main {
                        &__child {
                            margin-top: 35px;
                        }
                    }
                }
            }
        }

        @include breakpoint(xs) {
            padding-top: 60px;
            padding-bottom: 50px;
            height: auto;

            &__row {
                .search_bar {
                    padding: 0 10px;
                    right: 0px;
                }

                &__tab {
                    .v-tabs__bar {
                        padding: 0 5px;
                    }

                    &__main {
                        &__child {
                            margin-top: 55px;

                            .items {
                                margin: 15px 0px;

                                a {
                                    margin: 5px;
                                }
                            }

                            .v-window__container--is-active {
                                height: auto !important;
                                overflow: inherit !important;
                            }
                        }
                    }
                }
            }

            h2 {
                font-size: 17px;
                padding: 5px 15px 5px 15px;
                margin-bottom: 0;

                small {
                    font-size: 12px;
                }
            }

            .v-tabs__slider {
                height: 3px;
            }

            &__overView {
                padding: 10px 15px !important;
            }

            &__expansion {
                box-shadow: none !important;
                padding-bottom: 30px;

                .v-expansion-panel__header {
                    color: rgba($ypo-blue, 0.8);
                    padding: 3px 15px;
                }

                .v-expansion-panel__container--active {
                    .v-expansion-panel__header {
                        color: $ypo-blue;
                        font-weight: 600;
                        background: rgba($ypo-gray, 0.1);
                    }
                }

                .v-icon {
                    color: $ypo-blue !important;
                }

                .v-expansion-panel__body {
                    padding: 10px 15px;
                }
            }

            &__search {
                margin: 0px;

                .result {
                    padding: 10px 15px;

                    strong {
                        font-size: 14px;
                    }

                    em {
                        font-size: 13px;
                        margin: 4px 0;
                    }

                    p {
                        font-size: 12px;
                    }
                }
            }
        }
    }
</style>
